import { Pagination, Select } from "antd";
import { useEffect, useState } from "react";

interface CustomPaginationProps {
    paginationTotal?: number;
    currentPage?: number;
    pageSize?: number;
    onPageChange?: (page: number) => void;
    showSizeChanger?: boolean;
    onPageSizeChange?: (pageSize: number) => void;
}

const CustomPagination = (props: CustomPaginationProps) => {
    const [isMobile, setIsMobile] = useState(false);
    const [pageSizeDefault, setPageSizeDefault] = useState(10);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 430);
        };
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handlePageSizeChange = (value: number) => {
        setPageSizeDefault(value);
        if (props.onPageSizeChange) {
            props.onPageSizeChange(value);
        }
    };

    return (
        <>
            {
                !isMobile ? (
                    <>
                        {props.paginationTotal && props.paginationTotal > 1 ?
                            (
                                <>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                                        <Pagination
                                            className="ml-auto"
                                            defaultCurrent={1}
                                            current={props.currentPage}
                                            pageSize={props.pageSize}
                                            total={props.paginationTotal}
                                            onChange={(page) => props.onPageChange && props.onPageChange(page)}
                                            showSizeChanger={false} />

                                        {props.showSizeChanger && (
                                            <Select
                                                style={{ width: 70, marginTop: 20 }}
                                                defaultValue={pageSizeDefault}
                                                onChange={handlePageSizeChange}
                                                options={[
                                                    { value: 10, label: "10" },
                                                    { value: 20, label: "20" },
                                                    { value: 50, label: "50" },
                                                    { value: 100, label: "100" },
                                                ]}
                                            />
                                        )}
                                    </div>
                                </>
                            )
                            : null}
                    </>
                ) : null
            }
        </>
    )
};

export default CustomPagination;